import { component } from "picoapp";

export default component((node, context) => {
  context.on("theme", ({ theme }) => {
    node.dataset.theme = theme;
  });
});
